type PointerPosition = {
  x: number;
  y: number;
};

export function hasReachedDragThreshold(
  pointerDownPosition: PointerPosition,
  currentPosition: PointerPosition,
  dragThresholdPx: number
): boolean {
  if (dragThresholdPx === 0) return true;

  const deltaX = currentPosition.x - pointerDownPosition.x;
  const deltaY = currentPosition.y - pointerDownPosition.y;

  return deltaX * deltaX + deltaY * deltaY >= dragThresholdPx * dragThresholdPx;
}
